import { useEffect } from 'react';

import {
  ACTION_OPEN_SUBSCRIPTIONS,
  SubscriptionsSidePage,
} from 'App/components/Subscriptions';
import {
  ACTION_OPEN_NOTIFICATIONS_SETTINGS,
  NotificationsSettings,
} from 'components/NotificationsSettings';

import { useLocation, useNavigate } from '@gogame/screens';

export const useEmailCallbackSidePage = (toggleDrawer) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.action === ACTION_OPEN_SUBSCRIPTIONS) {
      toggleDrawer(SubscriptionsSidePage, {
        onClose: () => {
          navigate(location.state, { state: null });
        },
      });
    }
    if (location.state?.action === ACTION_OPEN_NOTIFICATIONS_SETTINGS) {
      toggleDrawer(NotificationsSettings, {
        onClose: () => {
          navigate(location.state, { state: null });
        },
      });
    }
  }, [location.state?.action]);
};
